import PropTypes from 'prop-types';
import React from 'react';

export const Button = ({
  className,
  children,
  dataTestId,
  onClick,
  onKeyPress,
  text = '',
}) => (
  <button
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
    onKeyPress={onKeyPress}
    type="button"
  >
    {text}
    {children}
  </button>
);

Button.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  text: PropTypes.string,
};

Button.defaultProps = {
  text: '',
};
